import React from "react";
import classnames from "classnames";
import styles from "./ProfileIcon.module.css";

/* eslint-disable jsx-a11y/anchor-is-valid */
const ProfileIcon = ({ onArrowClick, children }) => {
  return (
    <>
      <div className={classnames("", styles["profile-img-arrow"])}>
        <a onClick={onArrowClick} style={{ cursor: "pointer" }}>
          {children}
        </a>
      </div>
    </>
  );
};

export default ProfileIcon;
